import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getConfigRequest: null,
  getConfigSuccess: ['config'],
  getConfigFailure: ['error'],
});

export const ConfigTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/ConfigActions.js